// import React from 'react'
// import { getBranding } from '../../utils/getBranding';

// function Button({name, onClick, bool}) {
//   const branding = getBranding();
//   return (
//     <>
//     <button 
//       className={bool ?' bg-primary w-full   px-4 py-2 border-none rounded-lg font-bold text-white': ' bg-primary   px-4 py-2 border-none rounded-lg font-bold text-white'}
//       onClick={onClick}
//       type='submit' 
//      >{name}</button>   
//     </>
//   )
// }

// export default Button

import React from 'react';
import { getBranding } from '../../utils/getBranding';

function Button({ name, onClick, bool }) {
  const branding = getBranding();

  return (
    <button
      className="w-full px-4 py-2 border-none rounded-lg font-bold text-white"
      style={{
        backgroundColor: bool
          ? branding.color.primary
          : branding.color.primary
      }}
      onClick={onClick}
      type="submit"
    >
      {name}
    </button>
  );
}

export default Button;
